import ContactForm from "./forms/contact";
import GetStartedForm from "./forms/getstarted";
import AssessmentForm from "./forms/assessment";
import OnboardingForm from "./forms/onboarding";

const Form = ({ formId = "", planData = {} }) => {
  const clientKey = "citoslearners";

  if (formId === "Contact") {
    return <ContactForm clientKey={clientKey} formId={formId} />;
  }

  if (formId === "GetStarted") {
    return (
      <GetStartedForm
        clientKey={clientKey}
        formId={formId}
        planData={planData}
      />
    );
  }

  if (formId === "Assessment") {
    return (
      <AssessmentForm clientKey={clientKey} formId={formId} />
    );
  }

  if (formId === "Onboarding") {
    return (
      <OnboardingForm clientKey={clientKey} formId={formId} />
    );
  }

  return null;
};

export default Form;